export function buildOnfidoUrl(applicantId?: string) {
  return `https://dashboard.onfido.com/applicant/${applicantId}/details`;
}
